import { TFunction } from 'react-i18next';

import { HotelCategoryFilter } from 'types/Search/filter';

export const getHotelCategoryFilterLabel = (value: number, t: TFunction) =>
    `${t(
        value !== HotelCategoryFilter.Five
            ? 'TRANS-min-amount-stars[i]'
            : 'TRANS-amount-stars[i]',
        {
            postProcess: 'interval',
            count: value,
        }
    )}/${t('TRANS-other-reviews')}`;

export const buildHotelCategoryFilterLabel = (value: string, t: TFunction) => {
    const key = parseInt(value);

    return getHotelCategoryFilterLabel(key, t);
};
